import { FC } from 'react';

import StoryblokLink from '../StoryblokLink';

export interface FooterColumnProps {
  navigation_items: [];
  heading: string;
}

const FooterColumn: FC<FooterColumnProps> = ({ navigation_items, heading }) => {
  return (
    <>
      <div className="my-4 select-none lg:my-0">
        <span className="mb-4 grid cursor-pointer grid-cols-[1fr_auto] justify-center border-b-2 border-theme-gray-medium pb-1 align-middle text-base font-medium lg:max-w-48 lg:cursor-default lg:border-b-0 lg:pb-0">
          <span>{heading}</span>
        </span>
        <div
          className={`flex flex-col flex-wrap gap-2 overflow-hidden duration-200 lg:h-full lg:pl-0 ${
            navigation_items.length > 5 && `lg:h-1/2 lg:grow lg:columns-2`
          }`}
        >
          {navigation_items.map((v: any) => {
            return (
              <StoryblokLink key={v._uid} link={v.url}>
                <span className="mb-4 cursor-pointer text-base hover:text-theme-primary lg:max-w-48">
                  {v.label}
                </span>
              </StoryblokLink>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FooterColumn;
